import { useState } from 'react'
import TabletOutlinedIcon from '@mui/icons-material/TabletOutlined';
import Tooltip from './Tooltip';

const KioskLink = ({link}) => {
  const [copied, setCopied] = useState(false)
  
       const encodedLink = encodeURIComponent(link);
  
          const copyToClipboard = () => {
  
              navigator.clipboard.writeText(`https://deccos-website.web.app/kiosklink/${encodedLink}?variant=kiosk`)
  
              setCopied(true)
              setTimeout(() => {
                  setCopied(false)
              }, 1000)
          }  
    return (
      <div className='copy-link-container'>
          <Tooltip content='Kopieer zuillink' top='-60px'>
              <TabletOutlinedIcon className='icon-margin-left' onClick={copyToClipboard} />
          </Tooltip>
          {copied && <p className='copied'>Gekopieerd!</p>}
      </div>
    )
}

export default KioskLink